export var PaymentMethodId = /*#__PURE__*/function (PaymentMethodId) {
  PaymentMethodId["Afterpay"] = "afterpay";
  PaymentMethodId["PaypalExpress"] = "paypalexpress";
  PaymentMethodId["PaypalCommerce"] = "paypalcommerce";
  PaymentMethodId["PaypalCommerceCredit"] = "paypalcommercecredit";
  PaymentMethodId["PaypalCommerceCreditCards"] = "paypalcommercecreditcards";
  PaymentMethodId["StripeV3"] = "stripeupe";
  PaymentMethodId["GooglePay"] = "googlepaystripeupe";
  PaymentMethodId["ApplePay"] = "applepay";
  return PaymentMethodId;
}({});